<div
  [class]="
    'skymiles-medallion-banner skymiles-medallion-banner' +
    get360AndSkyPriority(content().details.tier, content().status.priority)
  "
>
  <idp-details
    [content]="content().details"
    (analytics)="analytics.emit($event)"
  ></idp-details>
  <idp-status
    [content]="content().status"
    (redirect)="handleRedirect($event)"
  ></idp-status>
</div>
